import { render, staticRenderFns } from "./Release500Sections.vue?vue&type=template&id=07fa2074&scoped=true&"
import script from "./Release500Sections.vue?vue&type=script&lang=js&"
export * from "./Release500Sections.vue?vue&type=script&lang=js&"
import style0 from "./Release500Sections.vue?vue&type=style&index=0&id=07fa2074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa2074",
  null
  
)

export default component.exports